export default __webpack_public_path__ + "static/media/404error.3da65558.svg";